import React from "react";
import { useLocation, Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "./LoyaltyBreadcrumbs.css";

export default function LoyaltyBreadcrumbs() {
  const { t } = useTranslation();
  const location = useLocation();
  const pathSegments = location.pathname.split("/").filter(Boolean);

  const breadcrumbItems = [
    { name: t("loyaltyProgram.breadcrumbHome"), path: "/", isActive: false },
    {
      name: t("loyaltyProgram.breadcrumbLoyaltyProgram"),
      path: "/loyalty-program",
      isActive:
        pathSegments.includes("loyalty-program") && pathSegments.length === 2,
    },
  ];

  // Add dynamic breadcrumb for offer detail
  if (pathSegments.length === 3 && pathSegments[1] === "loyalty-program") {
    breadcrumbItems.push({
      name: t("loyaltyProgram.breadcrumbOfferDetails"),
      path: location.pathname,
      isActive: true,
    });
  }

  return (
    <nav
      className="loyalty-breadcrumbs"
      aria-label="Breadcrumb navigation"
    >
      <ol className="breadcrumb-list">
        {breadcrumbItems.map((item, index) => (
          <li
            key={index}
            className="breadcrumb-item"
          >
            {index > 0 && <span className="breadcrumb-separator">/</span>}
            {item.isActive ? (
              <span
                className="breadcrumb-current"
                aria-current="page"
              >
                {item.name}
              </span>
            ) : (
              <Link
                to={item.path}
                className="breadcrumb-link"
              >
                {item.name}
              </Link>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}
